import { Component } from '@angular/core';

@Component({
    selector: 'structure-root',
    templateUrl: './structure.html',
})
export class StructureComponent {}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix Website/Website_Admin/src/app/structure/structure.component.ts